<template>
  <div class="up-digit-test">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>金额转大写测试页（upDigit）</span>
        <span class="header-tip">手动输入金额，实时展示小写与大写，自动校验角分一致性</span>
      </div>

      <!-- 输入区 -->
      <el-input
        v-model="amount"
        placeholder="输入金额：支持数字、负数、千分位逗号，如 110000.01 或 110,000.01"
        clearable
      >
        <el-button slot="append" @click="randomAmount">随机金额</el-button>
      </el-input>

      <!-- 快捷案例 -->
      <div class="case-row">
        <span class="case-label">快捷案例：</span>
        <el-button
          v-for="item in cases"
          :key="item"
          size="mini"
          plain
          @click="amount = item"
        >{{ item }}</el-button>
      </div>

      <el-divider></el-divider>

      <!-- 结果区 -->
      <div class="result-row">
        <span class="result-label">原始输入：</span>
        <span class="result-value">{{ amount === '' ? '(空)' : amount }}</span>
      </div>
      <div class="result-row">
        <span class="result-label">小写（numDigit）：</span>
        <span class="result-value">{{ smallText }} 元</span>
      </div>
      <div class="result-row">
        <span class="result-label">大写（upDigit）：</span>
        <span class="big-result">{{ bigText }}</span>
      </div>
      <div class="result-row">
        <span class="result-label">一致性校验：</span>
        <span :class="['consistency', consistent ? 'ok' : 'bad']">
          {{ consistent ? '√ 小写与大写的角/分一致' : '× 小写与大写的角/分不一致！' }}
        </span>
      </div>

      <el-divider></el-divider>

      <div class="tips">
        <p>说明：upDigit 已于 2026-08-26 修复分位浮点误差（先四舍五入到分再拆角/分）。</p>
        <p>修复前带分金额可能出现两种错误：丢分（如 110000.01 显示"壹拾壹万元整"）或分位少 1（如 10005.06 的陆分显示成伍分）。</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { upDigit, numDigit } from '@/filter';

export default {
  name: 'UpDigitTest',
  data() {
    return {
      amount: '110000.01',
      // 覆盖修复前的典型错误案例与常规回归案例
      cases: ['110000.01', '10005.06', '18.04', '110000.51', '1234567.89', '110001', '0', '-543.21', '110,000.01']
    };
  },
  computed: {
    smallText() {
      return numDigit(this.amount);
    },
    bigText() {
      return upDigit(this.amount);
    },
    // 自动校验：numDigit 小写的角/分 与 upDigit 大写的角/分 必须一致
    consistent() {
      const digitMap = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const m = String(this.smallText).match(/\.(\d\d)$/);
      const cents = m ? Number(m[1]) : 0;
      const jiao = Math.floor(cents / 10) % 10;
      const fen = cents % 10;
      const jMatch = String(this.bigText).match(/(.)角/);
      const fMatch = String(this.bigText).match(/(.)分/);
      const jOk = jiao === 0 ? !jMatch : !!jMatch && jMatch[1] === digitMap[jiao];
      const fOk = fen === 0 ? !fMatch : !!fMatch && fMatch[1] === digitMap[fen];
      return jOk && fOk;
    }
  },
  methods: {
    randomAmount() {
      const yuan = Math.floor(Math.random() * 10000000);
      const cents = Math.floor(Math.random() * 100);
      this.amount = `${yuan}.${String(cents).padStart(2, '0')}`;
    }
  }
};
</script>

<style scoped>
.up-digit-test {
  padding: 16px;
}
.card-header {
  display: flex;
  align-items: baseline;
}
.header-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
.case-row {
  margin-top: 12px;
}
.case-label {
  font-size: 13px;
  color: #606266;
  margin-right: 4px;
}
.result-row {
  margin: 10px 0;
  font-size: 14px;
}
.result-label {
  display: inline-block;
  width: 140px;
  color: #606266;
}
.big-result {
  font-size: 22px;
  font-weight: bold;
  color: #f56c6c;
}
.consistency.ok {
  color: #67c23a;
}
.consistency.bad {
  color: #f56c6c;
  font-weight: bold;
}
.tips {
  font-size: 12px;
  color: #909399;
  line-height: 20px;
}
</style>
